module.exports = __webpack_public_path__ + "img/ic_linkedin_2.433e84ee.svg";